module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('h6', [_vm._v("Two-factor authentication (2FA) strengthens access security by requiring two methods (also referred to as factors) to verify your identity.")]), _vm._v(" "), _c('h6', [_vm._v("It protects against phishing, social engineering, and password brute force attacks and secures your logins from attackers exploiting weak or stolen credentials.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "mt-20"
  }, [(!_vm.getGoogle2faInfo && !_vm.secret_key) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.generateSecret
    }
  }, [_vm._v("\n            Generate Secret Key to Enable 2FA\n            "), (_vm.loading) ? _c('span', {
    staticClass: "btn-loader"
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.getGoogle2faInfo && _vm.secret_key) ? _c('EnableGoogle2FA', {
    attrs: {
      "secret-key": _vm.secret_key,
      "qr-code": _vm.qr_code
    },
    on: {
      "getErrors": _vm.setErrors
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getGoogle2faInfo) ? _c('DisableGoogle2FA', {
    on: {
      "getErrors": _vm.setErrors,
      "resetSecretKey": _vm.resetSecretKey
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), (_vm.errors) ? _c('div', {
    staticClass: "card card-inverse card-danger"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n      Errors\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n      " + _vm._s(_vm.errors) + "\n    ")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  }), _vm._v(" Set Up Google 2FA\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("You can install Google Authenticator application using these links: "), _c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2",
      "target": "_blank"
    }
  }, [_vm._v("Android")]), _vm._v(" | "), _c('a', {
    attrs: {
      "href": "https://apps.apple.com/ru/app/google-authenticator/id388497605",
      "target": "_blank"
    }
  }, [_vm._v("iOS")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc3f323c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/accountSettings/Google2FA/Google2FA.vue
// module id = 980
// module chunks = 0